import { createBasicSelector } from 'util/redux'
import { selectCurrentConversationById } from '.'

export const selectConversationStateByConversationId = createBasicSelector(
  selectCurrentConversationById,
  ticket => ticket.state
)
